import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { MessageCircle, CheckCheck } from "lucide-react";

const when = (iso) => new Date(iso).toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", year: "2-digit", hour: "2-digit", minute: "2-digit" });
const mins = (a, b) => Math.max(0, Math.round((new Date(b) - new Date(a)) / 60000));
const dur = (m) => (m < 60 ? `${m} min` : `${Math.floor(m / 60)} h ${m % 60} min`);

export const WaHistory = ({ clientId }) => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get(`/clients/${clientId}/wa-history`).then((r) => setD(r.data)).catch(() => setD({ items: [], threads: [] })); }, [clientId]);
  if (!d) return <div className="py-6 text-center text-xs text-slate-500">Carregando...</div>;
  const open = d.threads.find((t) => t.status === "open");
  return (
    <div data-testid="wa-history" className="space-y-2">
      {open && <div data-testid="wa-history-open" className="rounded-lg border border-amber-500/30 bg-amber-500/10 px-3 py-2 text-xs text-amber-200">Aguardando retorno do Suporte</div>}
      {d.items.map((it, i) => it.kind === "in" ? (
        <div key={i} data-testid="wa-history-msg" className="rounded-lg border border-[#1F293D] bg-[#111827] px-3 py-2">
          <div className="flex items-center gap-1.5 text-[11px] text-slate-500"><MessageCircle className="h-3.5 w-3.5 text-[#25D366]" /> Cliente escreveu · {when(it.at)}</div>
          <div className="mt-1 break-words text-sm text-slate-200 [overflow-wrap:anywhere]">{it.text}</div>
        </div>
      ) : (
        <div key={i} data-testid="wa-history-handled" className="flex items-center gap-1.5 rounded-lg border border-emerald-500/20 bg-emerald-500/5 px-3 py-2 text-xs text-emerald-300">
          <CheckCheck className="h-3.5 w-3.5" /> Atendido {it.by ? `por ${it.by}` : ""} · {when(it.at)}
          {it.open_since && <span className="ml-auto text-slate-500">esperou {dur(mins(it.open_since, it.at))}</span>}
        </div>
      ))}
      {!d.items.length && <div data-testid="wa-history-empty" className="py-6 text-center text-xs text-slate-500">Este cliente ainda não escreveu no Financeiro.</div>}
    </div>
  );
};
